"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreditSafeScanModalCms = void 0;
var CreditSafeScanModalCms = /** @class */ (function () {
    function CreditSafeScanModalCms() {
        this.creditSafeScanTitleLabel = 'Identity credit check';
        this.creditSafeScanDescriptionLabel = 'To help protect your credit report from fraud, please '
            + 'answer each security question below. You previously gave the answers to an identity monitoring system.';
        this.creditSafeScanCTAButtonLabel = 'Submit answers';
        this.creditSafeScanHardStopErrorTxt = "<div><strong>Unable to complete order online</strong></div>\n    <div>You were unable answer the security questions correctly.</div>\n    <br/><div>Please call us at <a href=\"\">888.333.6651</a>, so we can help with your order.</div><br/>";
        this.creditSafeScanNumber = "<a href=\"\">888.333.6651</a>";
        this.creditSafeScanHardStopErrorLabel = "We're unable to complete your order online";
        this.creditSafeHardStopPrimaryBtnLabel = "Find a store";
        this.creditSafeHardStopSecondaryBtnLabel = "Exit Checkout";
    }
    return CreditSafeScanModalCms;
}());
exports.CreditSafeScanModalCms = CreditSafeScanModalCms;
//# sourceMappingURL=creditsafescanmodal.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/cards/CreditSafeScanModal/creditsafescanmodal.cms.js
// module id = 2017
// module chunks = 8